import {convertorSuggestionList} from './utilities';
interface ChooseRregisteredOffersSwitcherProps {
  type: string;
  postType: string;
  chosedSugestionUser: IChosedSugestionUser;
  is_saled: boolean;

  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const ChooseRregisteredOffersSwitcher = ({
  type,
  chosedSugestionUser,
  postType,
  is_saled,
  setChosedSugestionUser,
}: ChooseRregisteredOffersSwitcherProps) => {
  return convertorSuggestionList[type]({
    is_saled,
    postType,
    chosedSugestionUser,
    setChosedSugestionUser,
  });
};

export default ChooseRregisteredOffersSwitcher;
